import React, { Component } from 'react';
import Config from './Config';
import List from './List';
import { Scrollbars } from 'react-custom-scrollbars';
import SearchBox from './SearchBox';
import ComboBox from './ComboBox';
import './css/Product.css';
import TabbedPage from './TabbedPage';
import FX from './functions/functions';
import ProductHistory from './ProductHistory';
import ProductAllocation from './ProductAllocation';
import ProductImages from './ProductImages';
import ProductSetSelector from './ProductSetSelector';
import Modal from './Modal';
import CountryList from './functions/CountryList';
//import OrderEdge from './OrderEdge';

class Product extends Component {
  constructor(props) {
    super(props);
    this.list = React.createRef();
    this.state = { activeProduct: null, showSide: true, context: {show:false}, drawerState: undefined , drawerType: 'supplier', page: 1 };
    this.props.root.loadNextPage = undefined;
    this.props.root.autoKey = this.autoKey;
  }
  enterAction = {
    'activeProductQty' : (e) => {
      console.log(e.key);
      e.target.blur();
      this.addActiveItem();
    }
  }
autoKey = (e) => {
      if(this.props.root.state.detail){
          if(e.target.tagName === 'BODY'){
              //document.getElementById('item_search').value = '';
              //document.getElementById('item_search').focus();
          }
          if(e.key === 'Enter'){
              console.log(e.target.id.split("_")[0]);
              console.log(this.enterAction);
              if(typeof this.enterAction[e.target.id.split("_")[0]] === 'function'){
                 this.enterAction[e.target.id.split("_")[0]](e);
              }
          }
      }
      else{
        console.log(e);
      }
      console.log('xxx');
        console.log(e);
  }
  componentDidMount(){
    this.retrieveData(50, 1);
    this.ensureCompositeHydrated();
  }
  componentWillUnmount(){
    // Leaving the Products panel entirely (to another section) should reset the
    // catalogue search, so returning shows a fresh full list rather than a
    // still-filtered one. List <-> detail navigation does NOT unmount this
    // component, so an active search is kept (and shown in the box) while
    // drilling into a product, and Back restores it. Mutate in place (no
    // setState) — it's only read by retrieveData/the List on the next mount.
    // showArchived is deliberately NOT cleared here: it's a mode the client
    // works in (walk the archived SKUs, unarchive them one at a time), and it
    // stays visibly ticked, unlike a search term that leaves no trace.
    var cc = this.props.root.state.current_customer;
    if(cc && cc.products){
      cc.products.search = '';
      cc.products.listSearch = '';
      cc.products.page = 1;
    }
  }
  // A composite opened from the products list reuses the lightweight paged
  // record, which carries the product_composites join rows but not the
  // component products themselves (name/stock). retrieveDetail() hydrates those
  // by id, but the in-list / row-click paths set detail directly and skip it —
  // so the breakdown fell back to raw ids and Available stuck at the sentinel.
  // Hydrate here on any path that lands on a composite. hydrateProducts() is
  // idempotent (it skips already-cached ids), and the id guard stops re-runs.
  ensureCompositeHydrated = () => {
    var detail = this.props.root.state.detail;
    if(!(detail && detail.composite && detail.id && Array.isArray(detail.product_composites))){
      return;
    }
    if(this._hydratedCompositeId === detail.id){ return; }
    var cc = this.props.root.state.current_customer;
    var list = (cc && cc.products && cc.products.list) || [];
    var have = {};
    list.forEach(p => { if(p){ have[p.id] = true; } });
    var ids = detail.product_composites.map(pc => pc.component_product_id);
    if(ids.some(id => !have[id])){
      this._hydratedCompositeId = detail.id;
      FX.hydrateProducts(this.props.root, ids);
    }
  }
  // "Archived Only" tick-box: off (default) lists unarchived SKUs, on lists the
  // archived ones. See retrieveData for why it's archived-ONLY.
  //
  // The flag lives on current_customer.products (App state), not on this
  // component's state, for the same reason the list search does: this component
  // unmounts whenever the user leaves the Products panel, so component state
  // silently reset the box and dumped the client back into the live catalogue
  // mid-way through working the archived list. App state outlives the panel, so
  // the box stays ticked until it's unticked (or the client is switched, which
  // replaces current_customer and clears it).
  showArchived = () => {
    var products = this.props.root.state.current_customer.products;
    return !!(products && products.showArchived);
  }
  toggleShowArchived = (e) => {
    var checked = e.target.checked;
    var cc = this.props.root.state.current_customer;
    if(!cc.products){ cc.products = {list: []}; }
    cc.products.showArchived = checked;
    this.props.root.setState({ current_customer : cc }, () => {
      this.retrieveData(cc.products.limit || 50, 1);
    });
  }
  setPage = (page) => {
    if(page.action === '+1'){
      page.action = (this.state.page || 1) + 1;
    }
    else if(page.action === '-1'){
      page.action = (this.state.page || 1) - 1;
    }
    var limit = (this.props.root.state.current_customer.products && this.props.root.state.current_customer.products.limit) || 50;
    this.retrieveData(limit, page.action);
  }
  sortAction = (sortList, filter) => {
    // sort or a filter (archive / supplier / product-set) changed in the List;
    // refetch from page 1 against the server.
    var limit = (this.props.root.state.current_customer.products && this.props.root.state.current_customer.products.limit) || 50;
    this.retrieveData(limit, 1);
  }
  retrieveData = (limit, page) => {
    if(isNaN(limit)){
      limit = 50;
    }
    if(isNaN(page) || page < 1){
      page = 1;
    }
    var products = this.props.root.state.current_customer.products || {};

    // Translate the List's in-table sort (sortList: [{field, order}]) into the
    // product_paged "col:dir" format. Unknown columns fall back to id on the
    // backend whitelist.
    var sort = 'id:DESC';
    var sl = (this.list.current && this.list.current.state && this.list.current.state.sortList) || [];
    if(sl.length){
      sort = sl[0].field + ':' + (sl[0].order === 1 ? 'ASC' : 'DESC');
    }

    // Translate the active List filters into remote query params.
    // Default to archive=0 (hide archived SKUs) to match the live my.vdepot
    // behaviour; the "Archived Only" tick-box flips this to archive=1 —
    // ARCHIVED ONLY, not "everything". It's a work-list: clients tick it to
    // walk the archived SKUs unarchiving them one at a time, so each SKU must
    // drop out of the list as soon as it stops being archived (archive=-1
    // showed all records, so an unarchived SKU stayed put and the tick-box
    // looked broken). Ignored SKUs are never filtered here so the client can
    // still amend them.
    var archive = this.showArchived() ? 1 : 0, supplier_id = 0, product_set_id = 0;
    var filters = (this.list.current && this.list.current.getFilter && this.list.current.getFilter()) || [];
    filters.forEach(filt => {
      if(filt.active && filt.active.length){
        if(filt.field === 'archive'){ archive = parseInt(filt.active[0], 10); }
        else if(filt.field === 'supplier_id'){ supplier_id = parseInt(filt.active[0], 10); }
        else if(filt.field === 'product_set_id'){ product_set_id = parseInt(filt.active[0], 10); }
      }
    });

    var data = {
      customer_id: this.props.root.state.customer_id,
      page: page,
      limit: limit,
      sort: sort,
      // encodeQueryData does not encode values; encode the free-text search so
      // SKUs/names containing &, +, #, % etc. don't corrupt the query string.
      search: encodeURIComponent(products.search || ''),
      archive: archive,
      supplier_id: supplier_id,
      product_set_id: product_set_id
    };
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root, 'product_paged' + qs, (res, i) => {
      // Unarchiving (or archiving) shrinks the filtered set, so the page we
      // asked for can fall off the end — clearing the last archived SKU on the
      // final page would otherwise leave a blank list. Drop back to the last
      // page that exists. Terminates: the retry always asks for a lower page,
      // and pages >= 1 keeps page 1 out of the branch.
      if(res.products && !res.products.length && res.pages >= 1 && page > res.pages){
        this.retrieveData(limit, res.pages);
        return;
      }
      var currCust = this.props.root.state.current_customer;
      currCust.products.list = res.products;
      currCust.products.count = res.count;
      currCust.products.limit = res.limit;
      currCust.products.pages = res.pages;
      currCust.products.page = res.page;
      currCust.products.data = data;
      currCust.products.path = 'product_paged';
      this.setState({page: res.page});
      this.props.root.setState({ current_customer : currCust });
    });
  }
  // Drives remote catalogue search from the list page's "Filter in page" box:
  // set the search term and refetch from page 1 (debounced). `listSearch` is
  // the COMMITTED list search — Back from a detail restores it (see showList),
  // so a scratch search done inside a detail doesn't stick to the list.
  searchTextAction = (text) => {
    var cc = this.props.root.state.current_customer;
    if(!cc.products){ cc.products = {list: []}; }
    cc.products.search = text || '';
    cc.products.listSearch = text || '';
    this.props.root.setState({ current_customer : cc });
    if(this.searchTimer){ clearTimeout(this.searchTimer); }
    this.searchTimer = setTimeout(() => {
      this.retrieveData((this.props.root.state.current_customer.products.limit) || 50, 1);
    }, 250);
  }
  // The product-detail side list searches the catalogue too, but must not
  // disturb the list page's committed search: it sets only `search` (the live
  // query that drives the fetch), leaving `listSearch` intact so Back returns
  // to the original list rather than whatever was typed in the detail.
  detailSearchAction = (text) => {
    var cc = this.props.root.state.current_customer;
    if(!cc.products){ cc.products = {list: []}; }
    cc.products.search = text || '';
    this.props.root.setState({ current_customer : cc });
    if(this.searchTimer){ clearTimeout(this.searchTimer); }
    this.searchTimer = setTimeout(() => {
      this.retrieveData((this.props.root.state.current_customer.products.limit) || 50, 1);
    }, 250);
  }
  componentDidUpdate(){
    FX.doFocus(this);
    this.ensureCompositeHydrated();
    this.checkChecked();
    if(this.list.current && this.state.filter != this.list.current.getFilter()  ){
        this.setState({filter:this.list.current.getFilter()});
        console.log('______________________');
    }
  }
  checkChecked = () => {

    var current_customer = this.props.root.state.current_customer;
    var d = document.querySelectorAll('input.lineSelect:checked');
    var b = document.querySelectorAll('#Drawer.open');
    console.log(d);
    if( document.querySelector('.Panel') && document.querySelector('#Drawer')){
        /*if(d.length){
          document.querySelector('#Drawer').classList.add('open');
          document.querySelector('.Panel').classList.add('openDraw');
          console.log(document.querySelector('.Products #Drawer .option').length);
          console.log(document.querySelector('.Products #Drawer .option').offsetHeight);
          console.log(document.querySelector('.Products #Drawer .option').offsetWidth);
          console.log(document.querySelector('.Products #Drawer').offsetWidth);
          console.log(document.querySelectorAll('.Products #Drawer .option').length / (document.querySelector('.Products #Drawer').offsetWidth / document.querySelector('.Products #Drawer .option').offsetWidth));
          document.querySelector('#Drawer').style.height = (document.querySelector('.Products .options').offsetHeight + 60) + 'px';
          //document.querySelector('.Panel').style.paddingBottom = (document.querySelector('.Products .options').offsetHeight + 60) + 'px';
          document.querySelector('.Panel').style.paddingBottom = document.querySelector('#Drawer').style.height = Math.ceil(document.querySelectorAll('#Drawer .option').length / (Math.floor(parseInt(window.getComputedStyle(document.querySelector('#Drawer')).width,10) / (parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginLeft,10) + parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginRight,10)+ parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).width,10))))) * (parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginTop,10) + parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginBottom,10)+ parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).height,10)) + 80 +  'px';

        }
        else {
          document.querySelector('#Drawer').classList.remove('open');
          document.querySelector('.Panel').classList.remove('openDraw');
          document.querySelector('#Drawer').style.height = null;
          document.querySelector('.Panel').style.paddingBottom = null;
        }
        */
        var pager = document.querySelector('.Products .PageState');
        if(this.state.drawerState) {
          document.querySelector('.Panel').style.paddingBottom = document.querySelector('#Drawer').style.height = Math.ceil(document.querySelectorAll('#Drawer .option').length / Math.floor((parseInt(window.getComputedStyle(document.querySelector('#Drawer')).width, 10) - parseInt(window.getComputedStyle(document.querySelector('#Drawer')).paddingLeft, 10) - parseInt(window.getComputedStyle(document.querySelector('#Drawer')).paddingRight, 10)) / (parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginLeft,10) + parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginRight,10)+ parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).width,10)))) * Math.ceil(parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginTop,10) + parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginBottom,10)+ parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).height,10)) + 80 +  'px';
          // Lift the pager so it floats just above the expanded drawer instead of
          // sitting on top of the Product Sets & Suppliers options.
          if(pager){ pager.style.bottom = document.querySelector('#Drawer').style.height; }
        }
        else {
          document.querySelector('.Panel').style.paddingBottom = document.querySelector('#Drawer').style.height = null;
          if(pager){ pager.style.bottom = null; }
        }
    }

  }
  selectProductLine = (prod) => {
    console.log(prod);
    var drawerState;
    var current_customer = this.props.root.state.current_customer;
    var d = document.querySelectorAll('input.lineSelect:checked');
    console.log(d);
    if(d.length){
          drawerState = 'open';
          document.querySelector('.Panel').classList.add('openDraw');
          document.querySelector('.Panel').style.paddingBottom = document.querySelector('#Drawer').style.height = Math.ceil(document.querySelectorAll('#Drawer .option').length / Math.floor((parseInt(window.getComputedStyle(document.querySelector('#Drawer')).width, 10) - parseInt(window.getComputedStyle(document.querySelector('#Drawer')).paddingLeft, 10) - parseInt(window.getComputedStyle(document.querySelector('#Drawer')).paddingRight, 10)) / (parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginLeft,10) + parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginRight,10)+ parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).width,10)))) * Math.ceil(parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginTop,10) + parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).marginBottom,10)+ parseInt(window.getComputedStyle(document.querySelector('#Drawer .option')).height,10)) + 80 +  'px';
    }
    else {
          drawerState = undefined;
          document.querySelector('.Panel').classList.remove('openDraw');
          document.querySelector('#Drawer').style.height = null;
    }
    console.log(current_customer.suppliers);
    console.log(current_customer.product_sets);

    this.setState({drawerState:drawerState, checked:!!d.length ? 'checked' : undefined});
  }
  selectProduct = (prod) => {
    console.log(prod);
    console.log(this.props.root.state.detail.dispatch_items);
    var product_composites = this.props.root.state.detail.product_composites;
    product_composites.some( (pc, i) => {
          console.log(pc.component_product_id);
        if(prod.id == pc.component_product_id){
          this.setState({activeProductQty : pc.component_quantity});
          console.log(pc);
          return true;
        }
        return false;
    });
    this.setState({activeProduct : prod});
    this.focusTgt = 'activeProductQty';
  }
  removeItem = (prod) => {
    var detail= this.props.root.state.detail;
    detail.product_composites.some( (pc, i) => {
        console.log(prod.id);
        console.log(pc);
        if(prod.id == pc.component_product_id){
          detail.product_composites.splice(i,1);
          return true;
        }
        return false;
    });
    this.props.root.setState({detail : detail});
  }
  addProduct = () => {
    var detail = this.props.root.setState({detail:{
      archive:0,
      barcode:null,
      composite:0,
      customer_id:this.props.root.state.customer_id,
      dim_1:0,
      dim_2:0,
      dim_3:0,
      id:-1,
      ignore:0,
      image:[],
      location_id:0,
      locations:[],
      manage:1,
      name:"",
      phantom:0,
      product_composites:[],
      product_expiry:[],
      qty:0,
      reorder:0,
      rrp:0,
      sku:"",
      status:1,
      stock:0,
      stock_alloc:0,
      stock_exp:0,
      stock_pre_order:0,
      update:1,
      value:0,
      hs_code:'',
      origin:'',
      v2_manufacturer_pid:'',
      description: '',
      weight:0}});
  }
  addActiveItem = () => {
    var detail= this.props.root.state.detail;
    var found = false;
    var product_composites = this.props.root.state.detail.product_composites;
    var activeProduct = this.state.activeProduct;
    product_composites.some( (pc, i) => {
        console.log(this.state.activeProduct.id);
        console.log(pc);
        if(this.state.activeProduct.id == pc.component_product_id){
          pc.component_quantity = parseInt(document.getElementById('activeProductQty').value, 10);
          found = true;
        }
        return found;
    });
    if (!found) {
      console.log(this.state.activeProduct.name);
      product_composites.push(
        {
          component_product_id:activeProduct.id,
          component_quantity: parseInt(document.getElementById('activeProductQty').value, 10),
          composite_product_id:detail.id,
          id:-1
        })
    }
    detail.product_composites = product_composites;
    this.props.root.setState({detail : detail});
    this.setState({activeProduct : null, activeProductQty:0});
    this.focusTgt = 'prod_search';
  }
  componentWillMount(){
    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    console.log(x);
    var found = false;
    if(x[1] && parseInt(x[1],10)){
        console.log(parseInt(x[1],10));
        var root_state = this.props.root.state;
        if(this.props.root.state.current_customer[x[0]]){
            this.props.root.state.current_customer[x[0]].list.some(
                (ping) => {
                  if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
                    root_state.detail = ping;
                    return found = true;
                  }
                  return false;
                }
            );
        }
     }
     if (x[1] && !found) {
        this.retrieveDetail(parseInt(x[1],10));
     }
  }
  retrieveDetail = (id) => {
    console.log('pop');
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {id: id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'product_detail' + qs , (res, i) => {
      this.props.root.setState({detail: res.product});
      // A composite references component products that are no longer resident;
      // hydrate them by id so the breakdown can render name/sku/stock.
      if(res.product && res.product.composite && Array.isArray(res.product.product_composites)){
        FX.hydrateProducts(this.props.root, res.product.product_composites.map(pc => pc.component_product_id));
      }
    });
  }
  showList = () => {
    // Returning to the list discards any scratch search done inside the detail:
    // restore the committed list search and refetch (the shared products.list
    // may now hold the detail's results), so the list shows what it did before.
    var cc = this.props.root.state.current_customer;
    if(cc && cc.products){
      cc.products.search = cc.products.listSearch || '';
      cc.products.page = 1;
    }
    FX.navigate.bind(this.props.root,this.props.root.state.panel, undefined ,'/products')();
    this.retrieveData((cc && cc.products && cc.products.limit) || 50, 1);
  }
  addFilter = (type,target) => {
      this.list.current.addFilter(type + '_id',target);
  }
  handle = (tgt, e) => {
      if(tgt === 'stock'){
         this.setState({stockChangeWarn: true});
      }
      else if(tgt === 'showNewGroup.name'){
         var showNewGroup = this.state.showNewGroup;
         showNewGroup.name = e.target.value;
         this.setState({showNewGroup: showNewGroup});
          return false;
      }








      this.props.root.changed = true;
      console.log(e.target.dataset && e.target.dataset.handling);
      if(tgt.indexOf('this.') !== -1){
          var out = {};
          out[tgt.substring(tgt.indexOf('this.') + 5)] = e.target.value;
          this.setState(out);
      }
      else if(tgt == 'sku') {
          var detail = this.props.root.state.detail;
          /*if(e.target.value.indexOf(' ') !== -1){
            alert('Please do not use spaces in your SKUs as they can cause ambiguities');
            e.target.value = e.target.value.replace(/ /g,'');
          }*/
          if(e.target.value.length > 36){
            alert('SKUs must have fewer than 36 Characters.');
            return false;
          }
          detail[tgt] = e.target.value.toUpperCase();
          this.props.root.setState({detail:detail});
      }
      else if(tgt == 'hs_code') {
          var detail = this.props.root.state.detail;
          // HS codes are digit strings, not numbers — keep leading zeros
          detail[tgt] = e.target.value.replace(/[^0-9]/g, '');
          this.props.root.setState({detail:detail});
      }
      else if(e.target.dataset.handling == 'number') {
          var detail = this.props.root.state.detail;
          detail[tgt] = FX.numberFix(e.target.value);
          this.props.root.setState({detail:detail});
      }
      else if(e.target.dataset.handling == 'float') {
          var detail = this.props.root.state.detail;
          detail[tgt] = FX.numberFix(e.target.value, true);
          this.props.root.setState({detail:detail});
      }
      else {
          var detail = this.props.root.state.detail;
          detail[tgt] = e.target.value;
          this.props.root.setState({detail:detail});
      }
  }
  handleClick = (tgt, e) => {
      this.props.root.changed = true;
      var detail = this.props.root.state.detail;
      detail[tgt] = 1 * e.target.checked;
      this.props.root.setState({detail:detail});
  }
  removeSupplier = (index, e) => {
      var detail = this.props.root.state.detail;
      detail.supplier.splice(index,1);
      this.props.root.setState(detail);
  }
  handleSupplier = (src, e) => {
      this.props.root.changed = true;
      var detail = this.props.root.state.detail
      console.log(document.getElementById(src).value)
      console.log(e)
      detail.supplier.push(
        {
          customer_id: this.props.root.customer_id,
          id: -1,
          name: document.getElementById(src).value
        }
      );
      this.props.root.setState(detail);
      document.getElementById('supplier_box').value = '';
  }
  removeProductSet = (index, e) => {
      var detail = this.props.root.state.detail;
      detail.product_set.splice(index,1);
      this.props.root.setState(detail);
  }
  toggleDrawer = () => {
    var d = document.querySelectorAll('input.lineSelect:checked');
    var drawerState = (this.state.drawerState === 'open') ? undefined : 'open';
    var checked;
    if(d.length){
        for(var i = 0; i < d.length; i++){
            console.log(d[i]);
            d[i].checked = false;
        }
        drawerState = undefined;
        checked = undefined;
    }
    this.setState({drawerState : drawerState,checked:checked});
    console.log(drawerState);
  }
  handleProductSet = (src, e) => {
      this.props.root.changed = true;
      var detail = this.props.root.state.detail
      console.log(document.getElementById(src).value)
      console.log(e)
      if(!Array.isArray(detail.product_set)){
          detail.product_set = [];
      }
      detail.product_set.push(
        {
          customer_id: this.props.root.customer_id,
          id: -1,
          name: document.getElementById(src).value
        }
      );
      this.props.root.setState(detail);
      document.getElementById('product_set_box').value = '';
  }
  clearSupplier = (value, e) => {
      document.getElementById('supplier_box').value = '';
      //e.target.value = '';
  }
  clearProductSet = (value, e) => {
      document.getElementById('product_set_box').value = '';
      //e.target.value = '';
  }
  delete = () => {
    if(window.confirm("Delete this product?")){
        var current_customer = this.props.root.state.current_customer;
        console.log(this.props.root.state.detail);
        var detail = this.props.root.state.detail;
        FX.load(this.props.root,'product/delete' , (res, i) => {

              console.log(res);
              console.log(res.success);
              this.props.root.setState({detail : undefined, current_customer : current_customer});
              if(res.success){
                  // Refetch the current page rather than splicing a resident list.
                  this.retrieveData(current_customer.products.limit || 50, current_customer.products.page || 1);
              }
        }, {method:'POST', data:{product : detail}});
    }
  }
  isAdmin = () => {
    var user = this.props.root.state.user;
    return parseInt(user.admin_level, 10);
  }
  groupClick = (type, target) => {
    if(document.querySelectorAll('.Products input.lineSelect:checked').length){
      this.addToGroup(type, target);
    }
    else {
      this.filterGroup(type, target);
    }
    if(this.list.current  ){
        this.setState({filter:this.list.current.getFilter()});
        console.log('______________________');
    }
  }
  addToGroup = (type, target) => {
    if((target && target.toString() && target.toString().toLowerCase() == 'new') && !this.state.showNewGroup ){
        this.setState({showNewGroup: {customer_id: this.props.root.state.customer_id, name:''}});
        return false;
    }
    var current_customer = this.props.root.state.current_customer;
    var detail = this.state.detail;
    console.log(type, target);
    var d = document.querySelectorAll('.Products input.lineSelect:checked');
    var list = [];
    var request = {};
    for(var i = 0; i < d.length; i++){
      list.push(document.querySelectorAll('.Products input.lineSelect:checked')[i].dataset.obj_id)
    }
    request[type + '_id'] = target;
    request['products'] = list;

    console.log(request);

    FX.load(this.props.root,type + '/link2?customer_id=' + this.props.root.state.customer_id , (res, i) => {
          // link2 returns only {success, suppliers, product_sets} (no full
          // catalogue) — the OOM-safe variant. We refetch the current page below.
          if(res.suppliers){
            current_customer.suppliers = res.suppliers;
          }
          if(res.product_sets){
            current_customer.product_sets = res.product_sets;
          }

          console.log(res.success);
          this.props.root.setState({current_customer : current_customer});
          this.props.root.changed = false;
          this.toggleDrawer();
          this.setState({showNewGroup: false});
          this.retrieveData(current_customer.products.limit || 50, current_customer.products.page || 1);
    }, {method:'POST', data:{request:request, newGroup: this.state.showNewGroup}});
  }
  filterGroup = (type, target) => {
    console.log(type, target);
    this.addFilter(type, target);
  }
  save = () => {
    var current_customer = this.props.root.state.current_customer;
    console.log(this.props.root.state.detail);
    var detail = this.props.root.state.detail;
    if(!detail.sku){
      alert('Please enter a SKU for this product');
      return false;
    }
    if(!detail.name){
      alert('Please enter a Name for this product');
      return false;
    }
    if(this.state.stockChangeWarn && !this.state.reason){
      this.setState({showWarn:true});
      return false;
    }
    FX.load(this.props.root,'product/save' , (res, i) => {
          if(res.suppliers){
            current_customer.suppliers = res.suppliers;
          }
          if(res.product_sets){
            current_customer.product_sets = res.product_sets;
          }
          this.props.root.setState({detail : res.product, current_customer : current_customer});
          this.props.root.changed = false;
          // Refetch the current server page so the list reflects the change
          // (edit or newly-created product) without relying on a resident cache.
          this.retrieveData(current_customer.products.limit || 50, current_customer.products.page || 1);
    }, {method:'POST', data:{product : detail, reason: this.state.reason}});
    this.setState({reason: undefined});
  }
  location_delete = (tgt) => {
      console.log(tgt)
      var detail = this.props.root.state.detail;
      for(var i = 0; i < detail.locations.length; i++){
          if(detail.locations[i].id == tgt){
              detail.locations.splice(i, 1);
          }
      }
      this.props.root.setState({detail : detail});
  }
  changeDrawer = (e) => {
      e.stopPropagation();
      console.log( e.target.value);
      this.setState({drawerType: e.target.value});
  }
  location_add = () => {
      var detail = this.props.root.state.detail;
      detail.locations.push({
        id:-1,
        product_id:detail.id,
        reference:document.getElementById("location_ref").value,
        warehouse_id:0
      });
      this.props.root.setState({detail : detail});
      document.getElementById("location_ref").value = '';
  }
  toggleSide = () => {
    this.setState({showSide:!this.state.showSide});
  }
  render() {
    if(!this.props.root.state.current_customer.products){
      return null
    }
    else if(this.props.root.state.detail){
      var detail = this.props.root.state.detail;
      var stockCtrl = '';
      var mainStock;
      if(!this.isAdmin()){
         mainStock = (
               <div className="mainStock">
                  {this.props.root.state.detail.stock}
                </div>)
      }
      else {
         mainStock = (
               <div className="mainStock">
                  <input value={this.props.root.state.detail.stock} data-handling="number" onChange={this.handle.bind(this, 'stock')} />
                </div>)
      }
      if(!this.props.root.state.detail.composite){
         stockCtrl = (
           <div  className="stockBox" >
               <div className="stockTitle">Stock</div>
               {mainStock}
                <div className="other_stock">
                  <div>
                    <label>Allocated:</label>
                    {this.props.root.state.detail.stock_alloc}
                  </div>
                  <div>
                    <label>Pre-Orderable:</label>
                    {this.props.root.state.detail.stock_pre_order}
                  </div>
                  <div>
                    <label>Expected:</label>
                    {this.props.root.state.detail.stock_exp}
                  </div>
                </div>
            </div>
          );
      }
      else {
         var pcs = this.props.root.state.detail.product_composites || [];
         var resolved = 0;
         var max_comp = pcs.length ? 999999999 : 0;
         pcs.forEach((pc) => {
            var component;
            if(this.props.root.state.current_customer.products){
              this.props.root.state.current_customer.products.list.some((prod) =>{
                if(prod.id == pc.component_product_id){
                  component = prod;
                  return true;
                }
                return false;
              });
              if(component){
                resolved++;
                max_comp = Math.max(0,Math.min( max_comp, Math.floor((parseInt(component.stock, 10) - parseInt(component.stock_alloc, 10) + parseInt(component.stock_pre_order, 10)) / pc.component_quantity)))
              }
            }
         });
         // Only trust the figure once every component resolved. With any child
         // still unresolved the min() would silently overstate (it ignores the
         // missing, possibly-zero-stock child) or sit at the 999999999 sentinel
         // — show a dash, not a misleading number, until hydrate fills them in.
         var allResolved = pcs.length > 0 && resolved === pcs.length;
         stockCtrl = (
           <div  className="stockBox" >
               <div className="stockTitle">Available</div>
               <div className="mainStock">
                  {allResolved ? max_comp : '—'}
                </div>
                {pcs.length > 0 && !allResolved ?
                  <div className="other_stock"><div>Loading component stock…</div></div> : null}
            </div>
          );
      }
      var prodLine = (click, current, obj) => {
        var curr = 'line';
        if (obj.id == current){
          curr += " current";
        }
        return (<div className={curr} onClick={click.bind(this,obj)}>
              <div className="name">{obj.name}</div>
              <div className="sku">{obj.sku}</div>
          </div>)
      };
      var locations;
      console.log(detail.locations);
      if(detail.locations){
          locations = detail.locations.map( loc => {
              console.log(loc);
              return <div>{loc.reference} <i className="fa fa-close" aria-hidden="true" onClick={this.location_delete.bind(this,loc.id)} /> </div>
          } )
      }









      var sideButtons;
      if (parseInt(detail.dispatch_status,10) >= 30) {
        sideButtons = (
            <div id="sideButtons">
              <button onClick={this.showList}>Back</button>
              </div>
        )
      }
      else {
        sideButtons = (
            <div id="sideButtons">
              <button onClick={this.showList}>Back</button>
              <button onClick={this.save}>Save</button>
              <button onClick={this.delete}>Delete</button>
            </div>
        )
      }
        var countriesOptions = CountryList.countries.map((nat, i)=>{
          return <option key={i} value={nat.country_code}>{nat.country}</option>
        })
      var stockVars;
      if(!this.props.root.state.detail.composite){
        stockVars = (<div>
                <div className="idents">
                    <div>
                      <label>Barcode:</label>
                      <input onChange={this.handle.bind(this, 'barcode')} value={this.props.root.state.detail.barcode}/>
                    </div>
                </div>
                <div className="dims">
                    <div>
                      <label>Height:</label>
                      <input className="medNumBox" data-handling="float" onChange={this.handle.bind(this, 'dim_1')} value={this.props.root.state.detail.dim_1}/>
                    </div>
                    <div>
                      <label>Length:</label>
                      <input className="medNumBox" data-handling="float" onChange={this.handle.bind(this, 'dim_2')} value={this.props.root.state.detail.dim_2}/>
                    </div>
                    <div>
                      <label>Width:</label>
                      <input className="medNumBox" data-handling="float" onChange={this.handle.bind(this, 'dim_3')} value={this.props.root.state.detail.dim_3}/>
                    </div>
                    <div>
                      <label>Weight:</label>
                      <input className="medNumBox" data-handling="float" onChange={this.handle.bind(this, 'weight')} value={this.props.root.state.detail.weight}/>
                    </div>
                </div>
                <div className="prices">
                    <div>
                      <label>Insurance:</label>
                      <input className="medNumBox" data-handling="float" onChange={this.handle.bind(this, 'value')} value={this.props.root.state.detail.value}/>
                    </div>
                    <div>
                      <label>RRP:</label>
                      <input className="medNumBox" data-handling="float" onChange={this.handle.bind(this, 'rrp')} value={this.props.root.state.detail.rrp}/>
                    </div>
                </div>
                <div className="customs">
                    <div>
                      <label>HS Code:</label>
                      <input className="medNumBox" onChange={this.handle.bind(this, 'hs_code')} value={this.props.root.state.detail.hs_code}/>
                    </div>
                    <div>
                      <label>Description:</label>
                      <input onChange={this.handle.bind(this, 'description')} value={this.props.root.state.detail.description}/>
                    </div>
                    <div>
                      <label>Origin:</label>
                      <select className="country_select" value={this.props.root.state.detail.origin} onChange={this.handle.bind(this,'origin')}>
                        <option>-----</option>
                        {countriesOptions}
                      </select>

                    </div>
                    <div>
                      <label>NS-PID:</label>
                      <input maxLength={45} title="Manufacturer product code - required for EU shipments" onChange={this.handle.bind(this, 'v2_manufacturer_pid')} value={this.props.root.state.detail.v2_manufacturer_pid || ''}/>
                    </div>
                </div>
                </div>);
      }
      else {
        var active;
        if (this.state.activeProduct){
          active = (
            <div className="activeProduct">{this.state.activeProduct.sku} - {this.state.activeProduct.name} <input id="activeProductQty" onChange={this.handle.bind(this, 'this.activeProductQty')} onFocus={(e) => {this.props.root.autoKey = this.autoKey;}} value={this.state.activeProductQty}/><button onClick={this.addActiveItem} ><i className="material-icons">add</i></button></div>
          );
        }
        var components = this.props.root.state.detail.product_composites.map((pc) => {
            var component;
              this.props.root.state.current_customer.products.list.some((prod) =>{
                if(prod.id == pc.component_product_id){
                  component = prod;
                  return true;
                }
              });
            if(component){
              if(parseInt(component.stock_alloc, 10)){

              }
                      /*<div>Stock On Hand: {component.stock} {component.stock_alloc}</div>*/
              return (
                    <div className="stockBox" >
                      <div onClick={this.removeItem.bind(this,component)} className="removeItem" style={{float: 'right'}}><i className="fa fa-close" aria-hidden="true" /></div>
                      <div className="component_desc">
                          <span className="stockName">{component.name}</span>
                          <span className="stockSKU">{component.sku}</span>
                          <span className="stockQty">{pc.component_quantity}</span>
                      </div>
                      <div>Effective Quantity: { Math.floor((parseInt(component.stock, 10) - parseInt(component.stock_alloc, 10) + parseInt(component.stock_pre_order, 10)) / pc.component_quantity) }</div>
                    </div>
                    );
            }
            // Component not yet in the cache (hydrate pending or failed).
            // Show the real component product id + qty in a consistent box
            // rather than the raw join-row id, so an unresolved child is
            // obvious instead of looking like a stray text line.
            return (
                  <div className="stockBox stockBoxPending" >
                    <div className="component_desc">
                        <span className="stockName">Loading component…</span>
                        <span className="stockSKU">product #{pc.component_product_id}</span>
                        <span className="stockQty">{pc.component_quantity}</span>
                    </div>
                    <div>Effective Quantity: —</div>
                  </div>
                  );
         });
         console.log(this.props.root.state.detail);
         stockVars = (
           <div>
               <div className="searchBox">
                  <SearchBox parent={this} root={this.props.root}></SearchBox>
                  {active}
               </div>
               {components}
            </div>
          );
      }

      var supplier;
      if(detail.supplier && detail.supplier.length){
        supplier = detail.supplier.map((sup,i) => {
          return (
          <div className="group_line">
              {sup.name}<button onClick={this.removeSupplier.bind(this,i)}><i className="fa fa-times" aria-hidden="true" /></button>
          </div>
        )})
      }
      var product_set;
      if(detail.product_set && detail.product_set.length){
        product_set = detail.product_set.map((ps,i) => {
          return (
          <div className="group_line">
              {ps.name}<button onClick={this.removeProductSet.bind(this,i)}><i className="fa fa-times" aria-hidden="true" /></button>
          </div>
        )})
      }
      var product_control;
      var product_control_tabs = [];
      var product_control_btns = [];
          product_control_btns.push( {text: 'Product Sets'} );
          product_control_tabs.push(
                      <div>
                        <div className="title">Product Sets</div>
                        <div className="itemList">
                          <div>
                          {product_set}
                          </div>
                          <span className="comboContainer"><ComboBox id="product_set_box" defaultValue="" product_id={detail.id} options={this.props.root.state.current_customer.product_sets} /></span>
                          <button className="add_btn" onClick={this.handleProductSet.bind(this,"product_set_box")}><i className="fa fa-plus" aria-hidden="true" /></button>
                        </div>
                      </div>
                  )
      if(!detail.composite){
          product_control_btns.push( {text: 'Suppliers'} );
          product_control_tabs.push(
                       <div>
                        <div className="title">Suppliers</div>
                        <div className="itemList">
                          <div>
                          {supplier}
                          </div>
                          <span className="comboContainer"><ComboBox id="supplier_box" defaultValue="" product_id={detail.id} options={this.props.root.state.current_customer.suppliers} /></span>
                          <button className="add_btn" onClick={this.handleSupplier.bind(this,"supplier_box")}><i className="fa fa-plus" aria-hidden="true" /></button>
                        </div>
                      </div>
                  )
      }
          product_control = (<TabbedPage className="prodGroup" buttons={product_control_btns}>
                      {product_control_tabs}
                  </TabbedPage>)

      var tabbedPage = [];
      var tabbedPageButtons = [];
      var locations;
      if(!detail.composite){
          tabbedPageButtons.push({text: 'History'});
          tabbedPage.push(<ProductHistory product_id={detail.id} root={this.props.root} />);
      }
      if(this.isAdmin() && !detail.composite){
        tabbedPageButtons.push({text: 'Locations', show: this.isAdmin()});
        tabbedPage.push( (<div id="ProductLocations">
                            <div className="title">Locations</div>
                            <div className="itemList">
                               {locations}
                               <div><input type="text" id="location_ref"/><button onClick={this.location_add} ><i className="fa fa-plus" aria-hidden="true" /></button></div>
                            </div>
                          </div>))
      }
      var expiries;
      console.log(detail.product_expiry && this.props.root.state.current_customer.customer.enable_expiries);
      if(detail.product_expiry && parseInt(this.props.root.state.current_customer.customer.enable_expiries,10)){
          expiries = detail.product_expiry.map( expi => {
              console.log(expi);
              return <div>{expi.expiry_date} {expi.stock} <i className="fa fa-close" aria-hidden="true" /> </div>
          } )
          tabbedPageButtons.push({text: 'Expiries', show: parseInt(this.props.root.state.current_customer.customer.enable_expiries,10)});
          tabbedPage.push ( ( <div id="ProductExpiries">
                        <div className="title">Expiry</div>
                          <div className="itemList">
                             {expiries}
                             <div><input type="text" /><button><i className="fa fa-plus" aria-hidden="true" /></button></div>
                          </div>
                        </div>) );
      }
      var batches;
      console.log(detail.product_expiry && this.props.root.state.current_customer.customer.enable_expiries);

      if(detail.product_expiry && parseInt(this.props.root.state.current_customer.customer.enable_expiries,10)){
          batches = detail.product_expiry.map( expi => {
              console.log(expi);
              return <div>{expi.expiry_date} {expi.stock} <i className="fa fa-close" aria-hidden="true" /> </div>
          } )
          tabbedPageButtons.push({text: 'Batch Nos.', show: parseInt(this.props.root.state.current_customer.customer.enable_batch_numbers,10)});
          tabbedPage.push ( ( <div id="ProductBatches">
                        <div className="title">Batch Numbers</div>
                        <div className="itemList">
                           {batches}
                           <div><input type="text" /><button><i className="fa fa-plus" aria-hidden="true" /></button></div>
                        </div>
                      </div>) );
      }
      tabbedPageButtons.push({text: 'Allocations'});
      tabbedPage.push(<ProductAllocation product_id={detail.id} root={this.props.root} />);
      var compositeSwitch;
      if(parseInt(this.props.root.state.current_customer.customer.enable_composites,10)) {
        compositeSwitch = (<div style={{padding:10}}>
                  <label>Composite:</label>
                  <input type="checkbox"  onClick={this.handleClick.bind(this, 'composite')} checked={this.props.root.state.detail.composite} />
                </div>)
      }
      if(!detail.composite){
        tabbedPage = (
                  <TabbedPage className="prodDetails" buttons={tabbedPageButtons}>
                    {tabbedPage}
                  </TabbedPage>
            )
      }
      else {
        tabbedPage= '';
      }
      var saveWarn;
      if(this.state.showWarn){
        saveWarn = (
            <Modal type="confirm" buttons={[{text:'Cancel', className:'cancel', action:(e) => {this.setState({showWarn:false, reason: ''})}},{className:'ok', text:'OK', action: (e)=>{this.setState({showWarn:false,stockChangeWarn:false}); this.save();}}]} >
               <p>Please enter a reason for the stock change for our records. e.g. Missing Stock or Breakage</p>
               <div className="title">Reason:</div>
               <textarea value={this.state.reason} onChange={this.handle.bind(this,'this.reason')}></textarea>
            </Modal>
         )
      }
      var toggleSide, sideBar;
      if ( this.state.showSide ) {
         toggleSide = (<div className="toggleSide" onClick={this.toggleSide}>Hide</div>);
         sideBar = (
           <div id="SideBar">
             <Scrollbars style={{ width: '100%' }}>
                 {stockCtrl}
                 {tabbedPage}
                 <ProductImages images={detail.image}  product={detail} root={this.props.root} />
                 {product_control}
                 {compositeSwitch}
             </Scrollbars>
             {sideButtons}
           </div>
         )
      }
      else {
         toggleSide = (<div className="toggleSide" onClick={this.toggleSide}>Show</div>);
      }
      return (
        <div className="Product">
          {toggleSide}
          {saveWarn}
          <div className="ProductList">
                <List current={this.props.root.state.detail.id} mini="true" item={prodLine} selectable={true} root={this.props.root} clickAction={Config.tables.products.click} searchAction={this.detailSearchAction} display={{object:"product", items:this.props.root.state.current_customer.products}} model={Config.tables.products} />
          </div>
          <div className="ProductItem">
                  <div className="productName">
                    <input placeholder="Name" onChange={this.handle.bind(this, 'name')} value={this.props.root.state.detail.name}/>
                    <i className="fa fa-pencil-square-o" aria-hidden="true"/>
                  </div>
                  <div>
                    <label>SKU:</label>
                    <input onChange={this.handle.bind(this, 'sku')} value={this.props.root.state.detail.sku}/>
                  </div>
                {stockVars}
                <div className="controls">
                    <div>
                      <label>Reorder:</label>
                      <input className="numBox" data-handling="number" onChange={this.handle.bind(this, 'reorder')} value={this.props.root.state.detail.reorder}/>
                    </div>
                    <div>
                      <label>Ignore:</label>
                      <input className="medNumBox" type="checkbox" onClick={this.handleClick.bind(this, 'ignore')} checked={this.props.root.state.detail.ignore}/>
                    </div>
                    <div>
                      <label>Manage:</label>
                      <input className="medNumBox" type="checkbox" onClick={this.handleClick.bind(this, 'manage')} checked={this.props.root.state.detail.manage}/>
                    </div>
                    <div>
                      <label>Archive:</label>
                      <input className="medNumBox" type="checkbox" onClick={this.handleClick.bind(this, 'archive')} checked={this.props.root.state.detail.archive}/>
                    </div>
                </div>
                {sideBar}
          </div>
        </div>
      );
    }
    else {
      var drawer_info;
      var current_customer = this.props.root.state.current_customer;
      var groupTitle;
      var drawer_cont
      if(this.state.drawerType == 'supplier'){
          drawer_cont = current_customer.suppliers.map(sup => {
             var className = 'option';
             if(this.state.filter){
               this.state.filter.some(filt => {
                 if(filt.name == 'supplier_id'){
                   if(filt.active.includes(sup.id)){
                       if(filt.active.length == 1){
                           groupTitle = ( <div className="groupTitle">
                              {sup.name}
                            </div>)
                       }
                      className += ' filtering';
                   }
                   return true;
                 }
                 return false;
               })
             }
             return <div className={className} onClick={this.groupClick.bind(this, 'supplier' , sup.id)}><span>{sup.name}</span></div>
          })
          drawer_cont.push(<div className="option new_grp" onClick={this.groupClick.bind(this, 'supplier' ,'new')}><i className="fa fa-plus" aria-hidden="true" /></div>)
      }
      else {
          drawer_cont = current_customer.product_sets.map(ps => {
             var className = 'option';
             if(this.state.filter){
               this.state.filter.some(filt => {
                 if(filt.name == 'product_set_id'){
                   if(filt.active.includes(ps.id)){
                       if(filt.active.length == 1){
                           groupTitle = ( <div className="groupTitle">
                              {ps.name}
                            </div>)
                       }
                      className += ' filtering';
                   }
                   return true;
                 }
                 return false;
               })
             }
             return <div className={className} onClick={this.groupClick.bind(this, 'product_set' , ps.id)}><span>{ps.name}</span></div>
          })
          drawer_cont.push(<div className="option new_grp" onClick={this.groupClick.bind(this, 'product_set' ,'new')}><i className="fa fa-plus" aria-hidden="true" /></div>)
      }
      var bin = <ProductSetSelector bulkList={document.querySelectorAll('.List input:checked')} root={this.props.root} />
      var grpDialogue;
      if(this.state.showNewGroup){
          grpDialogue = (
                <Modal type="confirm" buttons={[{text:'Cancel', className:'cancel', action:(e) => {this.setState({showNewGroup:false, name: ''})}},{className:'ok', text:'OK', action: (e)=>{this.setState({showNewGroup:false}); this.addToGroup(this.state.drawerType,'new');}}]} >
                   <p>Please enter the new {this.state.drawerType}</p>
                   <div className="title">Name:</div>
                   <input value={this.state.showNewGroup.name} onChange={this.handle.bind(this,'showNewGroup.name')} />
                </Modal>
                        )
      }
      return (
        <div className="Products">
          <div className="controls">
            <button onClick={this.addProduct}><i className="fa fa-plus" aria-hidden="true" /> Add Product</button>
            <label className="showArchived">
              <input type="checkbox" checked={this.showArchived()} onChange={this.toggleShowArchived} /> Archived Only
            </label>
          </div>
          {groupTitle}
          {grpDialogue}
          <List ref={this.list} checkAction={this.selectProductLine} selectable={true} root={this.props.root} clickAction={Config.tables.products.click} display={{object:"product", items:this.props.root.state.current_customer.products}} options={['Not Archived','Archived']} model={Config.tables.products} setPage={this.setPage} sortAction={this.sortAction} searchAction={this.searchTextAction} search={true} showState={true} />
          <div id="Drawer" className={this.state.drawerState + ' ' + this.state.checked}>
            <div className="drawer_title" onClick={this.toggleDrawer}>
              Product Sets & Suppliers{drawer_info}
              <div className="type_select">
              <select onChange={this.changeDrawer} onClick={(e)=>{e.stopPropagation();}} value={this.state.drawType}>
                <option value="supplier">Suppliers</option>
                <option value="product_set">Product Sets</option>
              </select>
              </div>
            </div>
            <div className="options">
                {drawer_cont}
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/Product.js